import React from 'react'
import imgFlyersDigitales from "../../assets/img/advertising.png";
import imgFlyersMarketplace from "../../assets/img/feedback.png";
import {Col, Container, Row} from "react-bootstrap";
import {ShortcutCard} from "../shortcuts/ShortcutCard";
import {BotonRegresar} from "../BotonRegresar";

export const FolleteriaDigital = () => {
    const shortcuts = [
        {
            title: "Flyers Digitales",
            description: "Flyers Digitales",
            imgUrl: imgFlyersDigitales,
            url: "/mercadotecnia/flyers-digitales",
            backgroundColor: "rgba(102,185,179,0.42)", // Color personalizado
            textColor: "rgb(255, 255, 255)",
        },
        {
            title: "Marketplace",
            description: "Marketplace",
            imgUrl: imgFlyersMarketplace,
            url: "/mercadotecnia/flyers-marketplace",
            backgroundColor: "rgba(255, 206, 0, 0.42)", // Color personalizado
            textColor: "rgb(255, 255, 255)",
        },
        {
            title: "Material de apoyo",
            description: "Material de apoyo",
            imgUrl: imgFlyersMarketplace,
            url: "/mercadotecnia/material-de-apoyo",
            backgroundColor: "rgba(188,43,108,0.42)", // Color personalizado
            textColor: "rgb(255, 255, 255)",
        },
    ];

    return (
        <section className="shortcut-lineamientos" id="shortcuts-de-lineamientos">
            <Container>
                <div className={"banner-transparente"}>
                    <BotonRegresar/>
                    <h1 className="banner-title">Folletería Digital</h1>
                    <p className="banner-description">
                        Descubre y explora una amplia colección de folletos digitales interactivos. Encuentra
                        información actualizada, promociones y contenidos destacados, en un solo lugar y desde
                        cualquier dispositivo.
                    </p>
                </div>
                <Row className={"justify-content-center pb-5"}>
                    {shortcuts.map((shortcut, index) => (
                        <Col key={index} xs={6} sm={3} md={3} lg={3}>
                            <ShortcutCard {...shortcut} />
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
}
